import { ref, shallowRef } from 'vue';
import { errorMessage } from '@/api/http';
import { onPageRefresh } from './usePageRefresh';

// Loading state for a list page. `fetcher` returns the rows (it may read the
// page's current tab/filter). Stale responses are ignored when a newer load
// has started, e.g. after switching tabs quickly. The list also reloads
// when a notification for the page it's on is opened or arrives.
export function useListResource(fetcher) {
  const items = ref([]);
  const loading = shallowRef(false);
  const error = shallowRef('');
  let latest = 0;

  async function load() {
    const call = ++latest;
    loading.value = true;
    error.value = '';
    try {
      const rows = await fetcher();
      if (call === latest) items.value = Array.isArray(rows) ? rows : [];
    } catch (e) {
      if (call === latest) error.value = errorMessage(e, 'Could not load data.');
    } finally {
      if (call === latest) loading.value = false;
    }
  }

  onPageRefresh(load);

  return { items, loading, error, load };
}
